// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Serialized from "../Data.Serialized/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Restaumatic_Currencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_I18n_Currency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
var deserialize = /* #__PURE__ */ Data_Serialized.deserialize(Restaumatic_Currencies.unscrambleDecodeCurrency);
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Locales.eqLocale);
var getGlobalLocale = /* #__PURE__ */ Restaumatic_I18n.getGlobalLocale(Effect_Class.monadEffectEffect);
var getGlobalCurrency = function __do() {
    var x = $foreign.getGlobalCurrencyRaw();
    return deserialize(x);
};
var currency = function (value) {
    return Restaumatic_I18n_Currency.formatCurrency(Effect_Unsafe.unsafePerformEffect(getGlobalCurrency))(value);
};
var formatNumberAsCurrency = function ($8) {
    return currency(Data_Money_Rounded.fromNumber($8));
};
var _localizePath = function (locale) {
    return function (defaultLocale) {
        return function (path) {
            return "/" + (function () {
                var $7 = eq(locale)(defaultLocale);
                if ($7) {
                    return path;
                };
                return Restaumatic_Locales.toText(locale) + ("/" + (path + "/"));
            })();
        };
    };
};
var localizeRoute = function (path) {
    return function __do() {
        var locale = getGlobalLocale();
        var defaultLocale = Restaumatic_I18n.getGlobalDefaultLocale();
        return _localizePath(locale)(defaultLocale)(path);
    };
};
export {
    currency,
    formatNumberAsCurrency,
    getGlobalCurrency,
    localizeRoute
};
export {
    getGlobalDefaultLocale,
    getGlobalLocale,
    translate,
    translate_,
    translationPending,
    translationPending_
} from "../Restaumatic.I18n/index.js";
export {
    t
} from "../Restaumatic.Site.Translations.Keys/index.js";
